import { render, staticRenderFns } from "./PaymentImageModal.vue?vue&type=template&id=5ac1a866&"
import script from "./PaymentImageModal.vue?vue&type=script&lang=js&"
export * from "./PaymentImageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports